import { Controller } from "@hotwired/stimulus"
import { closeModal } from "../../website/modal"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.element.dataset.newsletterPromptReady = "true"
  }

  disconnect() {
    this.request?.abort()
    delete this.element.dataset.newsletterPromptReady
  }

  dismiss() {
    if (this.submitting) return

    const data = new FormData()
    data.append("user[newsletter_updated_at]", new Date().toISOString())
    this.persist(data)
  }

  submit(event) {
    event.preventDefault()
    if (this.submitting) return

    this.submitting = true
    this.setSubmitting(true)
    this.persist(new FormData(this.formTarget), { close: true })
  }

  async persist(data, { close = false } = {}) {
    this.request?.abort()
    const request = new AbortController()
    this.request = request
    this.element.setAttribute("aria-busy", "true")
    delete this.element.dataset.newsletterPromptError

    try {
      const response = await fetch(this.formTarget.action, {
        method: "PATCH",
        body: data,
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
          "X-Requested-With": "XMLHttpRequest"
        },
        signal: request.signal
      })

      if (!response.ok) throw new Error(`Unable to update newsletter preferences (${response.status})`)

      this.element.dataset.newsletterPromptSaved = "true"
      if (close) this.close()
    } catch (error) {
      if (error.name !== "AbortError") this.element.dataset.newsletterPromptError = "true"
    } finally {
      if (this.request === request) {
        this.request = null
        this.submitting = false
        this.setSubmitting(false)
        this.element.removeAttribute("aria-busy")
      }
    }
  }

  close() {
    closeModal("modal-reactive-weekly")
  }

  setSubmitting(submitting) {
    this.formTarget.querySelectorAll("button[type='submit'], input[type='submit']").forEach(button => {
      button.disabled = submitting
    })
  }
}
